(function(ebusy, $) {

	/**
	 * load a modal with the given target as content
	 */
	ebusy.loadModal = function(target) {

		// no target, no dialog: $.ajax would load this page itself into the dialog, and its scripts bind every
		// handler once more (course cards have only data-target, a reservation without details has no link)
		if(!target) {
			return;
		}

		$("#modal .modal-dialog").replaceWith("");

		// opensModal: if the dialog needs a login (401), it opens again after it (ebusy.global.js, login.js). The header
		// is set here as well: ?triggerModal= loads before ebusy.global.js's $.ajaxSetup (frontend.js bundles this file
		// first), and without it the server answers a missing login with a redirect to the start page, not a 401
		var request;
		$.ajax({
			url: target,
			dataType: "html",
			headers: { "X-Ajax-call": "true" },
			opensModal: true,
			xhr: function() {
				return request = $.ajaxSettings.xhr();
			}
		}).done(function(response) {

			// the page and its scripts come into this one: a redirect to another site (an open redirect of this one)
			// shows nothing
			if(request.responseURL && new URL(request.responseURL).origin !== location.origin) {
				$("#modal").modal('hide');
				return;
			}

			$("#modal").html(response);

			if($("#modal").is(":visible")) {
				$("#modal").modal('handleUpdate');
			} else {
				$("#modal").modal();
			}

			$(document).trigger("form.init");
			$(document).trigger("modal.load", {
				target: target,
				method: "GET"
			});
		}).fail(function() {
			$("#modal").modal('hide');
		});
	};

})(window.ebusy = window.ebusy || {}, window.jQuery);

$(function() {

	/**
	 * handle click events on modal triggers
	 */
	$(document).on("click", ".to-modal", function() {
		ebusy.loadModal($(this).attr("href"));
		return false;
	});

	/**
	 * handle click events on modal triggers within modals
	 */
	$(document).on("click", "button[data-target]:not([data-toggle]):not(.disabled), a[data-target]:not([data-toggle]):not(.disabled)", function() {

		var button = $(this);

		if (button.closest(".modal-dialog").length) {
			$("<div class='overlay' />").appendTo(button.parent());
			button.addClass("disabled");
		}

		var form = $(".modal-body form");

		if(form.length === 0) {
			ebusy.loadModal(button.data("target"));
			return false;
		}

		var target = button.data("target");
		var method = form.attr("method") ? form.attr("method") : "POST";
		var formData = ebusy.buildModalFormData(form);
		if(button.attr("name") === "button_confirm") {
			formData["button_confirm"] = button.attr("value") ? button.attr("value") : 1;
		}
		ebusy.sendModalFormData(method, target, formData);

		return false;
	});

	ebusy.buildModalFormData = function(form) {

		var serialize = form.serialize();
		var formData = {};

		if(serialize) {
			formData = serialize;
		}

		return formData;
	}
	
	ebusy.sendModalFormData = function(method, target, formData) {
		$.ajax({
			type: method,
			url: target,
			data: formData,
			success: function(data, textStatus, jqXHR) {

				var historyInsert = jqXHR.getResponseHeader("X-eBuSy-History-Insert");
				if (historyInsert) {
					window.history.pushState({}, '', historyInsert);
				}

				var windowLocation = jqXHR.getResponseHeader("X-eBuSy-Window-Location");				
				if (windowLocation) {
					
					if(window.ebusy.embed) {
						window.parent.postMessage({ type: "ebusy.redirect", url: windowLocation}, "*");
						return;
					}
					
					window.location = windowLocation;
					return;
				}
				
				$("#modal").html(data);
				$("#modal").scrollTop(0);
				
				$(document).trigger("form.init");
				$(document).trigger("modal.load", {
					target: target,
					method: method
				});
			},
			error: function() {
				$("#modal").modal('hide');
			}
		});
	}

	/**
	 * handle click events on flow triggers
	 */
	$(document).on("click", ".flow-link", function() {
		ebusy.loadModal($(this).attr("href"));
		return false;
	});

	/**
	 * prevent enter from submitting modal
	 */
	$(document).on("keydown", function(event) {

		if($("#modal form").length == 0) {
			return true;
		}
		
		if($("#modal .btn-primary").length == 0) {
			return true;
		}
		
		if(event.keyCode == 13) {
			
			if($(event.target).is("textarea")) {
				return true;
			}

			if($(event.target).is(":not(.no-submit-on-enter)")) {
				event.preventDefault();
				$("#modal .btn-primary").not("[disabled='disabled']").trigger("click");
				return false;
			}

			return true;
		}
	});

	/**
	 * show notification as bootbox alert
	 */
	if($("#notification").length === 1) {
		$("#modal").html($("#notification").html());
		$("#modal").modal();
		$(document).trigger("modal.load", {});
	}

	/**
	 * handle reload location on modal close
	 */
	$(document).on("hidden.bs.modal", "#modal", function (event) {
		if($(event.target).find(".modal-dialog.reload").length > 0) {
			
			var href = ebusy.removeParam(location.href, "triggerModal");
			href = ebusy.removeParam(href, "paymentId");
			href = ebusy.removeParam(href, "token");
			href = ebusy.removeParam(href, "payerId");
			
		    if(href.substr(-1) === '#') {
		    	href = href.substr(0, href.length - 1);
		    }
			
			location.href = href;
		}
	});

	/**
	 * fix autofocus for modal inputs
	 */
	$(document).on("shown.bs.modal", "#modal", function (event) {
		$("#modal").find("[autofocus]").focus();
		
		$("#modal").find("input[maxlength][maxlength!='']").each(function(){
			var characterCount = $(this).val().length;
	        var current = $('.max-length-label[data-target="' + this.name + '"]');
	        current.text(characterCount);
		});
	});

	$(document).on("modal.load", function (event) {

		if ($("#transponder-overlay[data-auto-show='true']").length) {
			return;
		}

		$("#modal").find("[autofocus], [data-autofocus='true']").focus();
	});
	
	$(document).on("keyup", "input[maxlength][maxlength!='']", function () {
        var characterCount = $(this).val().length;
        var current = $('.max-length-label[data-target="' + this.name + '"]');
        current.text(characterCount);
	}).trigger("keyup");

	/**
	 * triggers a modal if requested
	 */
	if(ebusy.triggerModal) {
		ebusy.loadModal(ebusy.triggerModal);
	}

});
